/**
 * Recorte de exibição por canal comercial da Visão de Carteira (Onda 2 / A05).
 *
 * Os 4 canais da lista fechada (decisão 6.7) + `SEM_CANAL` — as reservas
 * anteriores ao carimbo. Escondê-las faria volume sumir da comparação, então o
 * "sem canal" é uma fatia de pleno direito nos gráficos do administrador.
 * Cores são apresentação (deste componente), não semântica de domínio.
 */
import { tokens } from '@/theme'
import { CANAIS_COMERCIAIS, CANAL_LABEL, CanalComercial } from '@/types/statusReserva'

export type CanalDeRecorte = CanalComercial | 'SEM_CANAL'

export const CANAIS_DE_RECORTE: CanalDeRecorte[] = [...CANAIS_COMERCIAIS, 'SEM_CANAL']

export const CANAL_RECORTE_LABEL: Record<CanalDeRecorte, string> = {
  ...CANAL_LABEL,
  SEM_CANAL: 'Sem canal (reservas antigas)',
}

/** Rótulo curto para eixos e legendas apertadas (o longo fica no aria-label). */
export const CANAL_RECORTE_LABEL_CURTO: Record<CanalDeRecorte, string> = {
  DIRECT: 'Direto',
  CONSULTANT: 'Consultor',
  STRUCTURED_CONSULTANT_CHANNEL: 'Estruturado',
  STRUCTURED_CONSULTANT_WHITE_LABEL: 'White Label',
  SEM_CANAL: 'Sem canal',
}

export const CANAL_RECORTE_COR: Record<CanalDeRecorte, string> = {
  DIRECT: '#3578E5',
  CONSULTANT: tokens.brandPrimary,
  STRUCTURED_CONSULTANT_CHANNEL: '#8E44AD',
  STRUCTURED_CONSULTANT_WHITE_LABEL: '#2ECC71',
  SEM_CANAL: '#8395A7',
}

/** R$ por extenso (KPIs, tabelas, aria-label). */
export const formatBRL = (v: number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0)

/**
 * R$ abreviado para caber em card e eixo ("R$ 2,2 bi", "R$ 850 mil"). Só
 * apresentação: o valor exato continua no aria-label / tooltip.
 */
export const formatBRLCurto = (v: number) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(v || 0)

/** Percentual com uma casa e vírgula ("12,5%"). */
export const formatPct = (parte: number, total: number) => {
  const pct = total > 0 ? Math.round((parte / total) * 1000) / 10 : 0
  return `${String(pct).replace('.', ',')}%`
}
